import styled from 'styled-components';
import { pallette } from '../../config/pallette';

import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 350px;
  margin: 5px;
  padding: 10px 10px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${pallette.lightGray};
  padding: 25px;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${pallette.white};
  margin-bottom: 25px;
  border: 1px solid ${pallette.text};
`;

export const EyeButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  height: 30px;
  width: 30px;
`;

export const InputPasswordContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${pallette.white};
  margin-bottom: 25px;
  border: 1px solid ${pallette.text};
`;

export const Input = styled.input`
  border: none;
  font-size: 14px;
  flex: 1;
  padding: 10px;
  background-color: ${pallette.white};
  color: ${pallette.text};

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${pallette.black};
  }
`;

export const InputLabel = styled.span`
  font-size: 14px;
  margin-bottom: 10px;
  color: ${pallette.text};
  text-align: left;
  font-weight: bold;
`;

export const Button = styled.button`
  background-color: ${pallette.main};
  color: ${pallette.white};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  padding: 10px 0;
  margin-top: 10px;
  border: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  font-weight: bold;
`;

export const ErrorText = styled.span`
  font-size: 14px;
  color: ${pallette.error};
  text-align: left;
`;

export const Header = styled.h1`
  font-size: 25px;
  margin: 25px 0;
`;

export const Description = styled.p`
  font-size: 14px;
  text-align: left;
  margin-bottom: 25px;
`;

export const WarnBody = styled.p`
  font-size: 14px;
  text-align: left;
`;

export const BoldText = styled.span`
  font-weight: bold
`;

export const WarnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 5px;
  padding: 5px 15px;
  background-color: ${pallette.warn};
`;

export const LinkButton = styled(Link)`
  text-align: right;
  margin: 10px 0;
  font-size: 14px;
`;
